export default {
  SET_BANNERS(state, banners) {
    state.allBanners = [...banners]
    state.banners = banners
  },
}
